import React from "react";
import clsx from "clsx";

import "./zero-state-message.scss";

export function ZeroStateMessage({ className, text }) {
  const emptyStateText = text || `Nothing to show.`;
  return (
    <div className={clsx("zero-state-message", className)}>
      <div className="text">
        <span>{emptyStateText}</span>
      </div>
    </div>
  );
}
